
// ABOUTME: Navigation component that provides the top navigation bar with sidebar trigger and refer candidate button
// ABOUTME: Handles navigation between different views and includes responsive design elements

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { UserPlus, Bell } from 'lucide-react';
import { useNotifications } from '@/hooks/useNotifications';
import NotificationDrawer from '@/components/notifications/NotificationDrawer';

const Navigation = () => {
  const navigate = useNavigate();
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const { unreadCount } = useNotifications();

  return (
    <>
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-center h-16">
            {/* Sidebar Trigger */}
            <div className="flex items-center gap-3">
              <SidebarTrigger />
            </div>
            
            {/* Right side buttons */}
            <div className="flex items-center gap-3">
              {/* Notification Button */}
              <Button 
                variant="ghost" 
                size="sm" 
                className="relative text-black"
                onClick={() => setNotificationDrawerOpen(true)}
              >
                <Bell className="w-4 h-4" />
                {unreadCount > 0 && (
                  <Badge className="absolute -top-1 -right-1 w-5 h-5 text-xs bg-red-500 border-white flex items-center justify-center">
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </Badge>
                )}
              </Button>
              
              {/* Refer a Candidate Button */}
              <Button 
                onClick={() => navigate('/role-hub')}
                className="bg-primary hover:bg-primary/90 text-primary-foreground"
              >
                <UserPlus className="w-4 h-4" />
                <span className="hidden sm:inline ml-2">Refer a Candidate</span>
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <NotificationDrawer 
        open={notificationDrawerOpen} 
        onOpenChange={setNotificationDrawerOpen} 
      />
    </>
  );
};

export default Navigation;
